import React from "react";

const Chair = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M25.188 17.313v3.125H10.813v-3.125a1.875 1.875 0 1 0-3.75 0v3.75c0 1.725 1.399 3.125 3.125 3.125h15.624c1.726 0 3.125-1.4 3.125-3.125v-3.75a1.875 1.875 0 1 0-3.75 0Zm-1.35 12.83a.938.938 0 0 0-.838-.518h-3.125v-3.563h-3.75v3.563H13a.938.938 0 0 0-.838.518l-1.25 2.5a.937.937 0 1 0 1.677.839l.99-1.982h3.483v1.563a.938.938 0 0 0 1.875 0V31.5h3.484l.99 1.982a.938.938 0 0 0 1.677-.839l-1.25-2.5Z"
            fill={fill}
        />
        <path
            className="u_fill"
            d="M12.688 17.313v1.25h10.624v-1.25a3.75 3.75 0 0 1 3.75-3.75c0-2.11-.663-4.204-1.875-5.93V5.437A3.441 3.441 0 0 0 21.75 2h-7.5a3.441 3.441 0 0 0-3.438 3.438v2.195a10.383 10.383 0 0 0-1.874 5.93 3.75 3.75 0 0 1 3.75 3.75ZM15.5 5.75h5a.938.938 0 0 1 0 1.875h-5a.938.938 0 0 1 0-1.875Zm0 3.75h5a.938.938 0 0 1 0 1.875h-5a.938.938 0 0 1 0-1.875Zm0 3.75h5a.938.938 0 0 1 0 1.875h-5a.938.938 0 0 1 0-1.875Z"
            fill={fill}
        />
    </svg>
);

export default Chair;
